<div class="px-3">


  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">

      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-file font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">File Ingestion Config</div>
        <div class="text-right mt-2">Manage file ingeston configs</div>
      </div>
      
    </div>
  </div>


  <div class="flex justify-content-between">
    <div class="flex flex-row gap-3">
      <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
      ></creditor-autocomplete>

       <!-- <remitter-button
        (click)="search()" 
        label='Get'
        icon='search'
       >     
       </remitter-button> -->
         
    </div>

    <div  *ngIf="!isHideAddNew">
      <remitter-button   
        (click)="onOpenSideBar()" 
        label='Add New'
        icon='plus'
        severity='info'
       >     
      </remitter-button>
    </div>
   
</div>
<div class="mt-4">
    <div 
      *ngIf="!hasTableData && hasSearch"
      style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
            🚫 No records found for {{ creditorCompanyName }}
    </div>
    <p-table 
      *ngIf="hasTableData"
      [value]="fileIngestionConfigs" [tableStyle]="{ 'min-width': '50rem' }" >
        <ng-template pTemplate="header">
            <tr class="text-xs">
                <th>File Ingestion Id</th>
                <th>Overwrite Amount DueOnly</th>
                <th>Missing Invoices Status</th>    
                <th>Action</th>         
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-contact>
            <tr class="text-xs">
                <td>{{ contact.FileIngestionConfigId }}</td>
                <td>{{ contact.OverwriteAmountDueOnly }}</td>
                <td>{{ getInvoiceStatusLabel(contact.MissingInvoicesStatusId) }}</td>   
                <td>
                    <div class="flex align-items-center">
                        <icon-button
                        pTooltip="Edit"
                        tooltipPosition='left'
                        (click)="onOpenSideBar(contact.FileIngestionConfigId, contact.OverwriteAmountDueOnly, contact.MissingInvoicesStatusId)"
                        [icon]="'pencil'"
                        [styleClass]="'mr-1'"
                       />  
                      
                       <icon-button
                        pTooltip='Delete'
                        tooltipPosition='left'
                        (click)="onOpenDeleteModal(contact)"
                        [icon]="'trash'"
                      />
                      </div>
                </td>       
            </tr>
        </ng-template>
    </p-table>
</div>

</div>

<common-delete-modal 
  [(visible)]="isDeleteModalVisible" 
  message="Are you sure you want to delete this File Ingestion Config?" 
  width="30vw"
  (actionClicked)="onConfirmDelete()">
</common-delete-modal>

<p-sidebar [(visible)]="isSideBarVisible" styleClass="w-4" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium">{{false? 'Edit ' : 'Add New '}} File Ingestion Config</div>
  
      <div class="flex align-items-center mt-4 gap-2">
        <div>Overwrite Amount Due Only</div>
        <p-inputSwitch [(ngModel)]="overwriteAmountDueOnly" />
      </div>

      <div class="mt-5">
        <p-floatLabel>
          <p-dropdown class="w-full" id="missingInvoiceStatus" [options]="invoiceStatuses" [(ngModel)]="missingInvoicesStatusId" optionLabel="label" optionValue="id" placeholder="Select Status"></p-dropdown>
          <label for="creditors">Missing Invoice Status</label>
        </p-floatLabel>
      </div>     
     
      <div class="flex justify-content-end mt-4">
        <remitter-button
          (click)="onSave()" 
          label='Save'
          icon='send'
        >     
        </remitter-button>
      </div>
    </div>
  </p-sidebar>
